module.exports = __webpack_public_path__ + "img/P4.226dd288.jpg";